var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudBottomRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 80,
    viewBox: "0 0 173 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M167.903 55.9563C161.526 51.7046 153.388 53.6617 148.343 60.6129C148.962 55.3489 146.63 50.0849 143.441 47.3179C140.253 44.4835 136.445 43.6736 132.686 43.3362C127.403 42.8638 120.835 44.416 119.217 51.5696C117.932 41.8515 112.364 33.6181 105.606 31.2561C98.8479 28.894 91.2333 32.5383 86.9024 40.2318C87.188 31.391 84.3801 22.6852 80.0492 16.274C75.7184 9.86271 70.0074 5.6785 64.0108 3.04651C54.9208 -0.93522 44.7838 -1.34012 35.9793 3.78889C27.1749 8.91789 19.8933 20.1207 18.2276 33.4156C17.4186 39.7594 17.9897 46.6431 20.6548 51.8396C16.895 48.0603 11.66 47.3854 7.47189 50.1524C3.33142 52.9869 0.333142 59.1282 0 65.6744L1.28498 73.7053C2.52236 77.4171 5.99655 78.092 8.85205 78.2269C51.7798 80.5215 94.7075 80.589 137.635 78.4294C146.202 78.0245 154.768 77.4846 163.239 75.46C165.476 74.9201 167.761 74.2452 169.664 72.558C171.568 70.8708 173.091 67.9015 172.996 64.6621C172.901 60.6804 170.473 57.6434 167.903 55.9563Z",
    fill: "#3E809D",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBottomRight);
export default __webpack_public_path__ + "static/media/cloud-bottom-right.41e2e1335aedb49577064f5adcfe3129.svg";
export { ForwardRef as ReactComponent };